import { SegmentedControl } from '@mantine/core';
import { useTranslation } from 'react-i18next';

import { setAdminLanguage, type AdminLanguage } from '../i18n';

type Props = {
    size?: 'xs' | 'sm' | 'md';
};

export const LanguageSwitcher = ({ size = 'xs' }: Props) => {
    const { t, i18n } = useTranslation();
    const value: AdminLanguage = i18n.language?.startsWith('en') ? 'en' : 'ru';

    return (
        <SegmentedControl
            size={size}
            value={value}
            onChange={(next) => setAdminLanguage(next)}
            data={[
                { label: 'RU', value: 'ru' },
                { label: 'EN', value: 'en' },
            ]}
            aria-label={t('common.language')}
        />
    );
};
